import React from 'react';
import { Server, Network, CreditCard, ShieldHalf, Check, ArrowUpRight } from 'lucide-react';
import { CONSULTING_PRACTICES } from '../mock';

const iconMap = { Server, Network, CreditCard, ShieldHalf };

const PracticeCard = ({ practice }) => {
  const Icon = iconMap[practice.icon] || Server;
  return (
    <div className="group relative rounded-3xl border border-slate-200 bg-white p-7 lg:p-8 hover:border-slate-300 hover:shadow-xl hover:shadow-slate-900/5 transition-all duration-300 flex flex-col">
      <div className="flex items-start justify-between">
        <div
          className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${practice.accent} flex items-center justify-center shadow-lg`}
        >
          <Icon size={22} className="text-white" strokeWidth={2} />
        </div>
      </div>

      <h3 className="mt-5 font-display text-[22px] font-semibold text-slate-900 tracking-tight">
        {practice.title}
      </h3>
      <p className="mt-1 text-[13.5px] font-medium text-indigo-600">
        {practice.tagline}
      </p>

      <p className="mt-4 text-[14.5px] leading-relaxed text-slate-600">
        {practice.description}
      </p>

      <div className="mt-5 pt-5 border-t border-slate-100">
        <div className="text-[11.5px] font-medium tracking-[0.14em] text-slate-400 uppercase">
          What we cover
        </div>
        <ul className="mt-3 space-y-2">
          {practice.bullets.map((b) => (
            <li
              key={b}
              className="flex items-start gap-2 text-[13.5px] text-slate-700"
            >
              <Check size={15} className="mt-0.5 text-emerald-500 flex-none" strokeWidth={2.5} />
              <span>{b}</span>
            </li>
          ))}
        </ul>
      </div>

      <a
        href="#contact"
        className="mt-6 inline-flex items-center gap-1 text-[13.5px] font-medium text-slate-700 hover:text-slate-900 transition-colors"
      >
        Discuss this practice
        <ArrowUpRight
          size={15}
          className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </a>
    </div>
  );
};

const Consulting = () => {
  return (
    <section id="consulting" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[12px] font-medium text-slate-700 uppercase tracking-[0.18em]">
            Consulting
          </div>
          <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-semibold tracking-tight text-slate-900">
            Two consulting practices.{' '}
            <span className="bg-gradient-to-r from-sky-500 via-teal-500 to-amber-500 bg-clip-text text-transparent">
              Deep specialisation.
            </span>
          </h2>
          <p className="mt-5 text-[16.5px] leading-relaxed text-slate-600 max-w-2xl">
            Advisory engagements led by senior practitioners across infrastructure and platform engineering, and digital payments operations.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {CONSULTING_PRACTICES.map((p) => (
            <PracticeCard key={p.id} practice={p} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Consulting;
